module.exports = __webpack_public_path__ + "static/media/coursecard2023-10-25.9de16118.png";